import { useState } from "react";
import {
  MenuItem,
  MenuList,
  Grow,
  Popper,
  ClickAwayListener,
  Paper,
  ButtonGroup,
  Button,
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Grid,
  Fab,
  Drawer,
  useMediaQuery,
  useTheme,
  Box,
  IconButton,
  Typography,
} from "@mui/material";
import "./add.scss";
import { useImportContext } from "../../contexts/import.context";
import { voltar } from "../../utils";
import { Loading } from "../../components";

const AddLayout = ({
  id,
  showUpdate,
  formSubmit,
  onClickSalvar,
  onClickLog,
  loading,
  title,
  userLog,
  ButtonMenu,
  actions,
  isFullscreenDialog,
  children,
  actionsTotalizadores,
  submitSimples,
  formState,
  resetFormFunction,
  onClickVoltar,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const opcoes = ["SALVAR E ADICIONAR NOVO"];
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [openTotais, setOpenTotais] = useState(false);
  const { initialDtos, initialCollapses } = useImportContext();

  const handleClick = () => {
    onClickSalvar(0);
    setOpen(false);
  };

  const handleSubmit = (e) => {
    if (formSubmit) {
      document.getElementById("form-button")?.click();
      return;
    }
    id ? onClickSalvar(e) : handleClick();
  };

  const handleMenuClick = () => {
    onClickSalvar(1);
    setOpen(false);
  };

  const handleToggle = (event) => {
    setOpen((prevOpen) => !prevOpen);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event) => {
    if (anchorEl && anchorEl.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const voltarInitial = async () => {
    initialDtos();
    initialCollapses();
    resetFormFunction?.();
    if (onClickVoltar) return onClickVoltar();
    await voltar(formState);
  };

  const mobileBottomPadding = 80;

  return (
    <Box
      className={`add-layout-container ${isFullscreenDialog ? "p-4" : ""}`}
      sx={{
        position: "relative",
        height: "100%",
        minHeight: 0,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      <Card
        className="add-layout-card"
        sx={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          minHeight: 0,
          overflow: "hidden",
        }}
      >
        <CardHeader
          title={title}
          action={
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              {actions}
              {ButtonMenu}
            </Box>
          }
          botaoVoltar={!isFullscreenDialog}
          onClickVoltar={voltarInitial}
          userLog={userLog}
          onClickLog={onClickLog}
        />

        <CardContent
          className="add-layout-card-content rolagem"
          sx={{
            flex: 1,
            overflowY: "auto",
            p: { xs: 1, sm: 2 },
            pb: isMobile ? `${mobileBottomPadding}px` : { xs: 1, sm: 2 },
          }}
        >
          {children}
        </CardContent>

        {!isMobile && (
          <CardActions
            className="card-actions-wrapper"
            sx={{
              p: { xs: 1, sm: 2 },
              borderTop: "1px solid rgba(0,0,0,0.1)",
              backgroundColor: "#fff",
            }}
          >
            <Grid container alignItems="center" spacing={1}>
              <Grid item>
                {id ? (
                  showUpdate && (
                    <Button
                      onClick={handleSubmit}
                      variant="contained"
                      color="primary"
                      sx={{ fontWeight: 700, minWidth: "120px" }}
                    >
                      Atualizar
                    </Button>
                  )
                ) : (
                  <ButtonGroup variant="contained" color="primary">
                    <Button onClick={handleSubmit} sx={{ fontWeight: 700 }}>
                      SALVAR
                    </Button>
                    {!submitSimples && (
                      <Button size="small" onClick={handleToggle}>
                        <i
                          className="ph-fill ph-caret-down"
                          style={{ color: "#fff" }}
                        ></i>
                      </Button>
                    )}
                  </ButtonGroup>
                )}
              </Grid>

              <Grid item xs>
                <Box sx={{ width: "100%" }}>{actionsTotalizadores}</Box>
              </Grid>
            </Grid>
          </CardActions>
        )}
      </Card>

      {isMobile && (
        <>
          <Box
            sx={{
              position: "fixed",
              bottom: 16,
              left: 16,
              right: 16,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              zIndex: 1000,
              pointerEvents: "none",
            }}
          >
            <Box sx={{ display: "flex", gap: 1, pointerEvents: "auto" }}>
              <Popper
                open={open}
                anchorEl={anchorEl}
                transition
                placement="top-start"
                style={{ zIndex: 1300 }}
              >
                {({ TransitionProps }) => (
                  <Grow {...TransitionProps}>
                    <Paper sx={{ mb: 1, boxShadow: 3 }}>
                      <ClickAwayListener onClickAway={handleClose}>
                        <MenuList>
                          {opcoes.map((option) => (
                            <MenuItem key={option} onClick={handleMenuClick}>
                              {option}
                            </MenuItem>
                          ))}
                        </MenuList>
                      </ClickAwayListener>
                    </Paper>
                  </Grow>
                )}
              </Popper>

              <Fab color="primary" aria-label="save" onClick={handleSubmit}>
                <i
                  className="ph-bold ph-floppy-disk"
                  style={{ color: "#fff", fontSize: "24px" }}
                ></i>
              </Fab>
            </Box>

            {actionsTotalizadores && (
              <Box sx={{ pointerEvents: "auto" }}>
                <Fab
                  size="small"
                  color="inherit"
                  onClick={() => setOpenTotais(true)}
                  sx={{ backgroundColor: "background.paper", boxShadow: 2 }}
                >
                  <i
                    className="ph ph-projector-screen-chart"
                    style={{ fontSize: "20px" }}
                  ></i>
                </Fab>
              </Box>
            )}
          </Box>

          <Drawer
            anchor="bottom"
            open={openTotais}
            onClose={() => setOpenTotais(false)}
            PaperProps={{
              sx: {
                borderTopLeftRadius: 16,
                borderTopRightRadius: 16,
                p: 2,
                maxHeight: "70vh",
              },
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 1,
              }}
            >
              <Typography variant="h6">Totalizadores</Typography>
              <IconButton onClick={() => setOpenTotais(false)}>
                <i className="ph-bold ph-x"></i>
              </IconButton>
            </Box>
            <Box sx={{ overflowY: "auto" }}>{actionsTotalizadores}</Box>
          </Drawer>
        </>
      )}

      <Loading loading={loading} />
    </Box>
  );
};

export default AddLayout;
